"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsentPolicy = void 0;
const viewer_service_environment_1 = require("@wix/viewer-service-environment");
const consentPolicyApiFactory_1 = require("./consentPolicyApiFactory");
const consentPolicySsrApiFactory_1 = require("./consentPolicySsrApiFactory");
const createConsentPolicy = (config, getService) => {
    const envService = getService(viewer_service_environment_1.EnvironmentDefinition);
    const consentPolicyAPI = envService.isSSR()
        ? (0, consentPolicySsrApiFactory_1.consentPolicySsrApiFactory)(config, getService)
        : (0, consentPolicyApiFactory_1.consentPolicyApiFactory)(config, getService);
    return {
        ...consentPolicyAPI,
        currentConsentPolicy: consentPolicyAPI.getCurrentConsentPolicy(),
        openSettingModal: (categories = []) => {
            consentPolicyAPI.publishPolicyUpdateRequestedEvent(categories);
        },
    };
};
exports.createConsentPolicy = createConsentPolicy;
//# sourceMappingURL=consentPolicy.js.map